module.exports = __webpack_public_path__ + "img/blog_menu_pic7.fc157da5.png";